import React from 'react';
import {Blurhash} from "react-blurhash";

function Image({url, blurhash, aspectRatio, recordDuration = null, alt = '', onClick}) {
    return (
        <button type="button" onClick={onClick}>
            <div style={{
                borderRadius: 20,
                position: 'relative',
                aspectRatio,
            }}>
                <div style={{
                    position: 'absolute',
                    borderRadius: 20,
                    overflow: "hidden",
                    flex: 1,
                    inset: 0,
                    zIndex: 1,
                }}>
                    {blurhash !== null ? <Blurhash
                        punch={1}
                        width={'100%'}
                        height={'100%'}
                        className="object-cover"
                        style={{
                            // height: '100%',
                            borderRadius: 20,
                            aspectRatio: aspectRatio,
                        }}
                        hash={blurhash}
                    /> : <></>}
                </div>
                <img className="flex object-cover w-full"
                     style={{
                         borderRadius: 20,
                         aspectRatio: aspectRatio,
                         zIndex: 2,
                         position: 'absolute',
                         inset: 0,
                     }}
                     loading="lazy"
                     src={url}
                     alt={alt} />

                {recordDuration && <div
                    className={'z-10 font-bold drop-shadow-2xl absolute left-[15px] bottom-[10px] text-white-foreground'}>{recordDuration}</div>}

            </div>
        </button>
    )
}

export default Image;
